import { CartItem } from '@/types/cart.types';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { professionalDisplayName } from '@/utils/formatters/professional-name';

export interface CartItemEntity {
  name: string;
  avatar?: string;
  type: EntityTypeEnum;
}

export function getCartItemEntity({ professional, partner }: CartItem): CartItemEntity {
  if (professional) {
    return {
      name: professionalDisplayName({
        honorific: professional.honorific,
        name: professional.socialName || professional.legalName,
      }),
      avatar: professional.avatar,
      type: EntityTypeEnum.PROFESSIONAL,
    };
  }

  return {
    name: formatToTitleCase(partner.socialName),
    avatar: partner.avatar,
    type: EntityTypeEnum.LABORATORY_COLLECT_POINT,
  };
}
